<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/2myrMN/cover.jpeg?1684514753995" alt="This image is the cover for the book Pill God Returns, Book 21"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Pill God Returns, Book 21
      </h1>
      <p class="bookDescription body article font2">
        <p><strong>*He was the Supreme Pill God who got himself ambushed.But miraculously he had second chance！</strong></p><p>After living a new life, He was destined to rise strongly in order to cultivate the strongest Mystical Arts, refine the best Pill, control the strongest Ares-class, and have the most beautiful woman.</p><p>In this life, He know he is destined to go against the heavens<span style="font-size:12px">！</span></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Nan KeHuLv, Babel Novel
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Funstory
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?8bf548c0